import {Validate} from "./Validate";

export default Validate;